////////////////////////////////Running Code::::::::::::::::::::::::

export const options = [
  {
    id: 1,
    moduleName:"ATTENDANCE",
    name: "Attendance",
    src: require("./../../../../../../assets/icons/Date_range.svg").default,
    navigate : '/dashboard/viewattendance'
  },
  {
    id: 3,
    moduleName:"",
    name: "Flexi",
    src: require("./../../../../../../assets/icons/Timer.svg").default,
  },

  // { 
  //   id: 2,
  //   moduleName:"LEAVE",
  //   name: "Apply Leaves",
  //   src: require("./../../../../../../assets/icons/Create.svg").default,
  //   navigate : '/dashboard/applyleave' ,
  // },

  {
    id: 3,
    moduleName: "ATTENDANCE",
    name: "Team",
    src: require("./../../../../../../assets/icons/team.svg").default,
    navigate: "/dashboard/teamattendance"
  },

  {
    id: 7,
    moduleName:"MANATT",
    name: "Manual At..",
    src: require("./../../../../../../assets/icons/Assignment.svg").default,
    navigate:"/dashboard/manualattendance"
  },
  {
    id: 6,
    moduleName:"CANTEEN",
    name: "Wallet",
    src: require("./../../../../../../assets/icons/Payments.svg").default,
    navigate : '/dashboard/canteenpay'
  },
  
  {
    id: 8,
    moduleName:"CANTEEN",
    name: "Food Menu",
    src: require("./../../../../../../assets/icons/Fastfood.svg").default,
    navigate:"/dashboard/canteenlist" 
  },
  {
    id: 9,
    moduleName:"DIRECTORY",
    name: "Directory",
    src: require("./../../../../../../assets/icons/Phone.svg").default,
    navigate : '/dashboard/telephonedirectory'

  },
  {
    id: 19,
    moduleName:"ATTENDANCE",
    name: "Change Pic",
    src: require("./../../../../../../assets/icons/Perm_identity.svg").default,
    navigate : '/dashboard/changeface'
  },
  {
    id: 10,
    moduleName:"HELP",    
    name: "Help",
    src: require("./../../../../../../assets/icons/Help.svg").default,
    navigate : '/dashboard/help'
  },
  {
    id: 11,
    moduleName:"PROFILE",    
    name: "e-Visiting Card",
    src: require("./../../../../../../assets/icons/Perm_contact.svg").default,
    navigate : '/dashboard/profile'
  },

  { 
    id: 12,
    moduleName:"CANTEEN",
    name: "List Of Hospitals",
    src: require("../../../../../../assets/icons/Local_hospital.svg").default,
    navigate: '/dashboard/hospitallist'
  },

];






























